import script from "./DocsRequestBody.vue?vue&type=script&setup=true&lang=js"
export * from "./DocsRequestBody.vue?vue&type=script&setup=true&lang=js"

import "./DocsRequestBody.vue?vue&type=style&index=0&id=04d3d3c4&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-04d3d3c4"]])

export default __exports__